import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import querystring from 'querystring';
import SV from 'server-vars';
import get from 'lodash.get';
// components
import { FormattedMessage } from 'react-intl';
import { Button } from 'dibs-elements/exports/Button';

export const PdpSharedContactSupportButtonComponent = ({ user, item }) => {
    const contact1stdibs = (
        <FormattedMessage
            id="PdpSharedContactDealerButton.contact1stdibs"
            defaultMessage="Contact 1stdibs"
        />
    );
    let supportUrl;

    if (SV.get('locale') === 'de-DE') {
        const { dibsReference } = item;
        const profile = get(user, 'profile');
        let queryStringData;

        if (profile) {
            const { displayName, email } = profile;
            /* eslint-disable camelcase */
            queryStringData = {
                tfa_EmailAddress: displayName,
                tfa_Addresscontinued: email,
            };
        }
        queryStringData = Object.assign({}, queryStringData, { tfa_6980290243422: dibsReference });
        /* eslint-enable camelcase */
        const encodedQueryString = querystring.encode(queryStringData);
        supportUrl = `/contact/de/?${encodedQueryString}`;
    } else {
        supportUrl = 'https://support.1stdibs.com/s/';
    }

    return (
        <Button
            type="secondary"
            dataTn="item-actions-contact-1stdibs-support"
            size="small"
            fullWidth
            onClick={() => window.open(supportUrl)} // opens in new tab
        >
            {contact1stdibs}
        </Button>
    );
};
PdpSharedContactSupportButtonComponent.propTypes = {
    user: PropTypes.object.isRequired,
    item: PropTypes.object.isRequired,
};
export const PdpSharedContactSupportButton = createFragmentContainer(
    PdpSharedContactSupportButtonComponent,
    {
        user: graphql`
            fragment PdpSharedContactSupportButton_user on User {
                profile {
                    displayName
                    email
                }
            }
        `,
        item: graphql`
            fragment PdpSharedContactSupportButton_item on Item {
                dibsReference
            }
        `,
    }
);
